import PropTypes from 'prop-types';
import { TableRow, TableCell, TableHead } from '@mui/material';

const TeamListHead = ({ headLabel }) => (
  <TableHead>
    <TableRow>
      {headLabel.map((headCell) => (
        <TableCell key={headCell.id} align={headCell.alignRight ? 'right' : 'left'}>
          {headCell.label}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

TeamListHead.propTypes = {
  headLabel: PropTypes.array,
};

export default TeamListHead;
